import { pinia, useBusinessStore, useSessionStore, useStageStore } from '@/store'
import { ACTIVITY_CODE, lightTrack } from '@/utils/lightTrack'

// stage 编码 → 数字编号 (数据同事约定 1/2/3/4)
const STAGE_NO_MAP = { registration: '1', phase1: '2', phase2: '3', ended: '4' }

// 从 store 实时读取埋点上下文
function getContext() {
  const business = useBusinessStore(pinia)
  const session = useSessionStore(pinia)
  const stage = useStageStore(pinia)
  return {
    season_id: business.seasonInfo?.id ?? '',
    stage: stage.eventStage,
    stage_no: STAGE_NO_MAP[stage.eventStage] || '',
    pid: session.uid || '',
  }
}

// pv 事件: 页面访问
export function trackPv(page_name) {
  const ctx = getContext()
  lightTrack({
    action: 'pv',
    season_id: ctx.season_id,
    stage: ctx.stage,
    stage_no: ctx.stage_no,
    extra: {
      activity_code: ACTIVITY_CODE,
      page_name,
      pid: ctx.pid,
    }
  })
}

// page_stay 事件: 前台停留秒数
export function trackPageStay(page_name, duration_seconds) {
  const ctx = getContext()
  lightTrack({
    action: 'page_stay',
    season_id: ctx.season_id,
    stage: ctx.stage,
    stage_no: ctx.stage_no,
    duration_seconds,
    extra: {
      activity_code: ACTIVITY_CODE,
      page_name,
      pid: ctx.pid,
    }
  })
}

// ---- Session 生命周期 (方案 B: 每段前台激活期结束时上报 page_stay) ----
//   startPageSession(pageName) → 触发 pv, 开始计时
//   endPageSession()           → 上报当前前台段 (若有), 结束 session
//   visibilitychange → hidden  → 上报当前前台段, 暂停计时
//   visibilitychange → visible → 重开计时
//   pagehide                   → 上报最后一段

let activePage = null
let visibleStartAt = 0  // 当前前台段起点时间戳; 0 表示未在前台

function reportCurrentSegment() {
  if (!activePage || !visibleStartAt) return
  const dur = Math.floor((Date.now() - visibleStartAt) / 1000)
  if (dur > 0) trackPageStay(activePage, dur)
  visibleStartAt = 0
}

export function startPageSession(pageName) {
  if (!pageName) return
  activePage = pageName
  visibleStartAt = document.visibilityState === 'visible' ? Date.now() : 0
  trackPv(pageName)
}

export function endPageSession() {
  reportCurrentSegment()
  activePage = null
}

// visibilitychange / pagehide 全局监听 (仅注册一次)
let listenersInstalled = false
export function setupPageTrackListeners() {
  if (listenersInstalled || typeof document === 'undefined') return
  listenersInstalled = true

  document.addEventListener('visibilitychange', () => {
    if (!activePage) return
    if (document.visibilityState === 'hidden') {
      reportCurrentSegment()
    } else {
      visibleStartAt = Date.now()
    }
  })

  // pagehide 而非 beforeunload: 移动端 Safari 更可靠, 且能覆盖 bfcache 场景
  window.addEventListener('pagehide', () => endPageSession())
}
